export default "__VITE_ASSET__DXTp1AXq__"